import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

//Services
import { DailyReportsService } from '../../../../pages/field/service/daily-reports.service';

@Component({
  selector: 'app-time-worked-details-modal',
  templateUrl: './time-worked-details-modal.component.html',
  styleUrls: ['./time-worked-details-modal.component.css']
})
export class TimeWorkedDetailsModalComponent implements OnInit {
  @Input() selectedDay: any;
  @Input() isStartTime: any;

  loadingAttachment: boolean = false;
  maxWidth: number = 400;
  dailyTimeAttachmentData: any;
  constructor(private activeModal: NgbActiveModal, private dailyReportsService: DailyReportsService) { }

  ngOnInit(): void {
    var attachmentID = this.isStartTime ? this.selectedDay.StartAttachmentID : this.selectedDay.StopAttachmentID;
    if (attachmentID) {
      this.loadingAttachment = true;
      this.dailyReportsService.getVPAttachmentData(attachmentID, this.maxWidth, true).then((response: any) => {
        if (response != null && response.data != null) {
          this.dailyTimeAttachmentData = "data:image/png;base64," + response.data;
          setTimeout(() => {

          });
        }
        this.loadingAttachment = false;
      });
    }
  }

  cancelClicked() {
    this.activeModal.dismiss();
  }

}
